import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../../../Infra/display-name";
import { useWindowSize } from "../../useWindowSize";
import { TopBannerView } from "../AddJoinCommonComponents";
import { AddCommonInformedConsentParent } from "./AddJoinCommonInformedConsentViewStyles";
export const AddJoinCommonInformedConsentView = observer((props) => {
    const { model } = props;
    const topBannerRef = React.useRef(null);
    const windowSize = useWindowSize();
    React.useEffect(() => {
        var _a, _b;
        model.updateTopBannerHeight((_b = (_a = topBannerRef === null || topBannerRef === void 0 ? void 0 : topBannerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0);
    }, [topBannerRef, windowSize]);
    return (_jsxs(_Fragment, { children: [model.topBannerInfo && _jsx(TopBannerView, { ...model.topBannerInfo, ref: topBannerRef }), _jsx(AddCommonInformedConsentParent, { centerAligned: props.centerAligned, children: props.children })] }));
});
addDisplayName(AddJoinCommonInformedConsentView, "AddJoinCommonInformedConsentView");
